module.exports = __webpack_public_path__ + "img/rainbow3.78f866f3.png";